<template>
  <div class="tpl">
    <van-nav-bar title="亿家一家" left-text="返回" right-text="关注" @click-right="onClickRight" left-arrow fixed @click-left="onClickLeft" />
    <div style="height:46px"></div>
    <div class="kefu">
      <img src="../../assets/kefu.png" @click="kefuShow=true" />
      <!-- <i class="iconfont iconkefu11 icon" @click="kefuShow=true"></i> -->
    </div>
    <van-popup
      v-model="kefuShow"
      closeable
      position="bottom"
      :style="{ height: '30%' }"
      style="padding-top:40px"
    >
      <div
        class="merchant"
        style="background-color:#fff;margin:10px 0 10px 0; padding:10px; display:flex"
      >
        <div
          style="line-height:30px; border-right: 1px solid #b2b2b2; padding-right:30px; font-size:16px"
        >
          <div>
            <van-icon name="shop-collect" color="red" style="padding-right:10px" />商户信息：
          </div>
          <div>名称：{{item.merchant.merchant_name}}</div>
          <!-- <div>{{item.merchant.address}}</div> -->
          <div>
            <van-icon name="location-o" style="padding-right:10px" />
            {{item.merchant.address}}
          </div>
        </div>
        <div style="flex-grow:1; text-align:center">
          <van-image :src="GLOBAL.IMG + item.qrcode" style="width:100px; height:100px;" />
        </div>
      </div>
    </van-popup>
    <Haibao :id="id" :module="2"></Haibao>
    <div class="main-pic">
        <van-tag class="huodongTag" v-if="item.goods_level==1" mark type="danger">活动</van-tag>
        <vue-swpier :items="slide" autoplay="5000"></vue-swpier>
    </div>
    <!-- <img class="thumbnail" :src="GLOBAL.IMG + item.thumbnail" /> -->
    <div style="background-color:#fff;display: flex;  justify-content: space-between;">
      <div class="price">
        ¥
        <em>{{item.price}}</em>   <span style="text-decoration:line-through;font-size:14px; color:#88888888"> ¥{{item.yprice}}</span>
        <br />
        <span
          style="color:#88888888;"
          v-if="user.user.is_share==1 && user.user.customer_type==2"
        >群主最高返佣：{{item.share_money}}</span>
        <span
          style="color:#88888888; padding-left:10px;"
          v-if="user.user.is_share==1"
        >分享师返佣：{{item.share_sub_money}}</span>
      </div>
      <div style="padding:28px 20px 0 0;color:#888888">热度{{item.post_hits}}</div>
    </div>

    <div class="title" ref="merchant">{{item.post_title}}</div>
    <yijiaEWM></yijiaEWM>
    <div class="detail" v-html="item.post_content"></div>
    <Comment :id="id" module="2"></Comment>
    <Recommend module="qiang" :list="item.recommend_goods"></Recommend>
    <div style="height:50px"></div>
    <div class="bottom">
      <van-sku
        ref="sku"
        v-model="skuShow"
        :show-add-cart-btn="false"
        :sku="item.sku"
        :goods="item.goods"
        :goods-id="item.id"
        :quota="quota"
        :quota-used="quotaUsed"
        :message-config="messageConfig"
        @buy-clicked="onBuyClicked"
      />
      <van-goods-action style="padding-left:10px;">
        <van-goods-action-icon icon="home-o" text="首页" @click="goHome" />
        <van-count-down v-if="time>0" :time="time" format="  剩余：DD天HH时mm分ss秒" @finish="getDetail" />
        <div style="width:30px;"></div>
        <van-goods-action-icon
          v-if="item.is_collect"
          icon="star"
          text="取消收藏"
          v-on:click="shouCangCancle()"
          color="#ff5000"
        />
        <van-goods-action-icon
          v-if="!item.is_collect"
          icon="star"
          text="收藏"
          color="#1baeae"
          v-on:click="shouCang()"
        />
        <van-goods-action-button
          v-if="show_yuyue"
          type="danger"
          color="#1baeae"
          :text="yuyue.msg"
          @click="clickYuyueShow=true"
          :disabled="yuyue.disabled"
        />
        <van-goods-action-button
          v-if="!show_yuyue"
          type="danger"
          color="#1baeae"
          :text="buyShow.msg"
          @click="buy"
          :disabled="buyShow.disabled"
        />
      </van-goods-action>
    </div>
    <van-popup v-model="clickYuyueShow" round position="bottom" :style="{ height: '30%' }">
      <div style="font-size:18px; text-align:center;padding:10px;">请填写预约信息</div>
      <div>
        <van-field v-model="yuyue.name" label="姓名" />
        <van-field v-model="yuyue.mobile" type="tel" label="手机号" />
        <div style="height:20px;"></div>
        <van-button type="danger" v-on:click="yuyuePost()" size="large">立即预约</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import {
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Sku,
  Popup,
} from "vant";
import { CountDown } from "vant";
import Recommend from "@/components/tuijian.vue";
import Haibao from "@/components/haibao.vue";
import wx_share from "../../common/wx_share.js";
import { Tag } from "vant";
import vueSwpier from "@/components/vueSwiper_shopImg.vue";
import Comment from "@/components/comment.vue";
import yijiaEWM from "@/components/yijia.vue";

Vue.use(Tag);
Vue.use(CountDown);
Vue.use(GoodsAction)
  .use(GoodsActionButton)
  .use(GoodsActionIcon)
  .use(Sku)
  .use(Popup);
export default {
  name: "goodsDetail",
  components: {
    Recommend,
    vueSwpier,
    Comment,
    Haibao,
    yijiaEWM,
  },
  data() {
    return {
      kefuShow: false,
      slide: [],
      id: this.$route.params.id,
      user: { token: "", user: {id:0, is_share: 0, customer_type: 0 } },
      item: {
        sku: { tree: [], none_sku: true },
        goods: {},
        end_seconds: 0,
        merchant: { merchant_name: "" },
      },
      skuShow: false,

      messageConfig: {
        // 数据结构见下方文档
      },
      goodsId: "0",
      quota: 0,
      quotaUsed: 0,
      buyDetail: {
        goods_id: this.$route.params.id,
        num: 1,
        attr_json: { n1: "", n2: "", n3: "" },
        is_collect: 0,
      },
      time: 0,
      show_yuyue: false,
      yuyue: { disabled: true, msg: "", name: "", mobile: "" },
      buyShow: { disabled: true, msg: "" },
      clickYuyueShow: false, //控制填写预约信息窗口
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight(){
        this.$router.push("/article/detail/71");
    },
    goHome() {
      this.$router.push("/");
    },
    shouCang() {
      this.$http
        .post(
          this.GLOBAL.API + "/s_user/collection/add",
          { id: this.id, module: 2 },
          {
            params: {},
            headers: {
              "XX-Token": this.user.token,
              "XX-Device-Type": "mobile",
            },
          }
        )
        .then((response) => {
          let data = response.body;
          this.$toast(data.msg);
          if (data.code == 1) {
            this.item.is_collect = 1;
          }
        });
    },
    shouCangCancle() {
      this.$http
        .post(
          this.GLOBAL.API + "/s_user/collection/delete",
          { id: this.id, module: 2 },
          {
            params: {},
            headers: {
              "XX-Token": this.user.token,
              "XX-Device-Type": "mobile",
            },
          }
        )
        .then((response) => {
          let data = response.body;
          this.$toast(data.msg);
          if (data.code == 1) {
            this.item.is_collect = 0;
          }
        });
    },
    yuyuePost() {
      this.$http
        .post(
          this.GLOBAL.API + "s_qiang/appointment/commit",
          { id: this.id, name: this.yuyue.name, mobile: this.yuyue.mobile },
          {
            params: {},
            headers: {
              "XX-Token": this.user.token,
              "XX-Device-Type": "mobile",
            },
          }
        )
        .then((response) => {
          let data = response.body;
          this.$toast(data.msg);
          this.clickYuyueShow = false;
        });
    },
    onBuyClicked() {
      let sku = this.$refs.sku.getSkuData();
      this.buyDetail.num = sku.selectedNum;
      if (sku.selectedSkuComb.s1) {
        this.buyDetail.attr_json.n1 = sku.selectedSkuComb.s1;
      }
      if (sku.selectedSkuComb.s2) {
        this.buyDetail.attr_json.n2 = sku.selectedSkuComb.s2;
      }
      if (sku.selectedSkuComb.s3) {
        this.buyDetail.attr_json.n3 = sku.selectedSkuComb.s3;
      }
      localStorage.setItem("buyDetail", JSON.stringify(this.buyDetail));
      this.$router.push("/qiang/createorder/" + this.id);
    },

    buy() {
      this.skuShow = true;
    },
    getDetail() {
      this.slide = [];
      this.$http
        .get(this.GLOBAL.API + "s_qiang/goods/detail", {
          params: { id: this.id },
          headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" },
        })
        .then((response) => {
          let data = response.body;
          if (data.code == 1) {
            for (let i in data.data.thumbsnails) {
              this.slide.push({
                id: i,
                image: data.data.thumbsnails[i],
                url: "#",
              });
            }
            data.data.post_content = data.data.post_content.replace(
              /src="default/g,
              'width= 100% src="' + this.GLOBAL.IMG + "default"
            );
            data.data.post_content = data.data.post_content.replace(
              /src="groupshop/g,
              'width= 100% src="' + this.GLOBAL.IMG + "groupshop"
            );
            this.item = data.data;
            let info ={"post_title":this.item.post_title,"desc":this.item.post_title,"thumbnail":'http://yijia.sihandbms.cn/upload/'+this.item.thumbnail}
            wx_share.wx_share(this.GLOBAL.API,this.user,info);
            if (data.data.qiang_status == 0) {
              //0未开始，1正在进行，2抢购已结束
              this.buyShow.msg = "等待抢购";
              this.buyShow.disabled = true;
              this.time = data.data.begin_seconds * 1000;
            } else if (data.data.qiang_status == 1) {
              this.buyShow.msg = "立即抢购";
              this.buyShow.disabled = false;
              this.time = data.data.end_seconds * 1000;
            } else {
              this.buyShow.msg = "抢购已经结束";
              this.buyShow.disabled = true;
            }
            if (data.data.is_yuyue) {
              //如果是预约商品，走预约流程。
              if (data.data.yuyue_status == 2) {
                //1已预约2未开始，3已结束，4，进行中，0非预约商品
                this.show_yuyue = true;
                this.yuyue.msg = "预约未开始";
                this.yuyue.disabled = true;
                this.time = data.data.begin_seconds_yy * 1000;
              } else if (data.data.yuyue_status == 4) {
                this.show_yuyue = true;
                this.yuyue.msg = "立即预约";
                this.yuyue.disabled = false;
                this.time = data.data.end_seconds_yy * 1000;
              } else if (data.data.yuyue_status == 3) {
                this.show_yuyue = false;
                this.yuyue.disabled = true;
              } else if (data.data.yuyue_status == 1) {
                this.show_yuyue = false;
                this.yuyue.disabled = true;
              }
            }
          }
        });
    },
    
  },
  watch: {
    $route(to, from) {
      if (from.params.id) {
        //   this.$router.go(0);
        this.id = to.params.id;
        this.getDetail();
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 200);
      }
    },
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
    }
    this.getDetail();
    if (this.$route.query.share) {
      localStorage.setItem("share", this.$route.query.share);
    }
  },
};
</script>
<style lang="scss" scoped>
.tpl {
  text-align: left;
  background-color: #f6f6f6;
}
.main-pic{
    position: relative;
    .huodongTag{
        position: absolute;
        z-index: 999;
        top:0;
        left:0;
    }
}
.thumbnail {
  width: 100%;
  display: block;
}
.price {
  color: #f2270c;
  em {
    font-size: 30px;
    font-family: JDZH-Regular;
  }
  padding: 10px;
  background-color: #ffffff;
}
.title {
  font-size: 16px;
  color: #262626;
  font-weight: 700;
  padding: 10px;
  border-radius: 0 0 10px 10px;
  margin-bottom: 10px;
  background-color: #ffffff;
}
.detail {
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 10px;
}
.kefu {
  position: fixed;
  bottom: 150px;
  z-index: 999;
  width: 60px;
  height: 60px;
  right: 10px;
  text-align: right;
  background-color: #fff;
  border-radius: 30px;
  img{
      width:100%;
  }
  .icon {
    display: block;
    color: aqua;
    font-size: 40px;
    margin: -5px 4px 0 0px;
  }
}
</style>